import { SvgComponent } from './SvgComponent';
import { IconProps } from './types';

const DoubleArrowsReload = ({
  width = 24,
  height = 24,
  color = '#1677FF',
  ...props
}: IconProps) => (
  <SvgComponent width={width}
    height={height}
    viewBox='0 0 24 24'
    stroke={color}
    {...props}
  >
    <path d='M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4' />
    <path d='M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4' />
  </SvgComponent>
);

export default DoubleArrowsReload;
